import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "../../services/utility/autoMapperService";
import BaseListComponent from "../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../components/tableComponents/itemsTable";
import TableFilterPane from "../../components/tableComponents/tableFilterPane";
import { getCurrentUserSession } from "../../services/auth/authService";
import { decodeToken } from "react-jwt";
import feePaymentService from "../../services/billing/feePaymentService";
import InstitutionFeePayableReportDetail from "./institutionFeePayableReportDetail";
import activityTrailService from "../../services/auditTrail/activityTrailService";

export interface InstitutionFeePayableReportProps { }

export interface InstitutionFeePayableReportState
  extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class InstitutionFeePayableReportList extends BaseListComponent<InstitutionFeePayableReportState> { }

class InstitutionFeePayableReport extends React.Component<
  InstitutionFeePayableReportProps,
  InstitutionFeePayableReportState
> {
  constructor(props: InstitutionFeePayableReportProps) {
    super(props);
    this.state = {
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    const decodedToken = decodeToken(getCurrentUserSession().token || "");
    var institutionCode = decodedToken?.["InstitutionCode"] || ""
    try {
      const reportItems = await feePaymentService.filterPayableReportByInstitutionCode(
        institutionCode,
        pageSize,
        currentPage - 1
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: reportItems.data.data,
          properties: [
            { oldName: "feePaymentId", newName: "id" },
            { oldName: "serviceOffering", newName: "serviceOffering" },
            { oldName: "appzoneFee", newName: "appzoneFee" },
            { oldName: "paymentReference", newName: "paymentReference" },
            { oldName: "dateCreated", newName: "dateCreated" },
            {
              isTag: true,
              oldName: "status",
              newName: "status",
              success: "Paid",
              danger: "Unpaid",
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: reportItems.data.totalRecords,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async (type: string) => {
    try {
      const decodedToken = decodeToken(getCurrentUserSession().token || "");
      switch (type) {
        case "XLSX":
          return await feePaymentService.downloadPayableReport(decodedToken?.["InstitutionCode"], "EXCEL");
        case "CSV":
          return await feePaymentService.downloadPayableReport(decodedToken?.["InstitutionCode"], type);
        case "PDF":
          return await feePaymentService.downloadPayableReport(decodedToken?.["InstitutionCode"], type);
        default:
          break;
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        //this.setState({ errors, fetching: false });
      }
    }
  };

  fetchItemById = async (item: any) => {
    await activityTrailService.saveActivityTrail({
      actionType: "View Fee Payable Report",
      description: `Viewed Fee Payable Report`
    });
    this.setState({ fetchingDetail: true });
    const report = await feePaymentService.retrievePayableReportById(
      item.id
    );
    this.setState({ item: report.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Appzone Fee Payable Report</b>
              </h3>
            </div>
            <InstitutionFeePayableReportList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [],
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                showDetailsModal,
              }) => (
                <Fragment>
                  <InstitutionFeePayableReportDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="InstitutionFeePayableReport"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["appzoneFee", "thirdPartyFee"]}
                              amountInNaira={true}
                              timeColumn={["dateCreated"]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></InstitutionFeePayableReportList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InstitutionFeePayableReport;
